<template>
	<!-- {% for filter_i, db_filter in table_filters %} -->
	<!-- <pre>{{ tableFiltersData }}</pre> -->
	<template v-for="(dbFilter, index) in tableFiltersData" :key="dbFilter.label">

		<DataviewFiltersDropdown 
			:i="index"
			:dbFilter="dbFilter"
			:feTheme="feTheme"
			:dtPost="dtPost"
			:open="dbFilter.open"
			@filterSubmit="filterSubmit"
			@dropdownOpen="dropdownToggle"
			@ddClose="ddClose"

		/>

	</template>
	<!-- <pre>
		feTheme:: {{ feTheme }}
	</pre> -->
</template>


<script>

import DataviewFiltersDropdown from '@vueapp/components/dataviews/DataviewFiltersDropdown.vue'
export default {
	components: {
		DataviewFiltersDropdown
	},
	data() {
		return {			
			tableFiltersData: {},
			currentIndex: null
		}
	},
	emits: ['filter-submit'],
	// directives: {
	// 	clickOutSide,
	// },
	methods: {
		filterSubmit( evt ) {
			this.tableFiltersData = this.tableFiltersData.map( (item, index) => {
				if ( evt.filterKey == item.column_name ) {
					item.open = false
					item.active = null !== evt.filterValue ? true : false
				}
				return item
			})

			this.$emit('filter-submit', {
							filterValue: evt.filterValue,
							filterKey: evt.filterKey
						})
		},
		ddClose(evt) {
			this.tableFiltersData = this.tableFiltersData.map( (item, index) => {
				item.open = evt.i == index ? false : item.open
				return item
			})
		},

		dropdownToggle( evt ) {
			// evt.i
			// console.log('evt::', evt)
			this.tableFiltersData = this.tableFiltersData.map( (item, index) => {
				item.open = evt.i == index && ! item.open
				return item
			})
		},

		// customMethod(index) {
		// 	console.log( this )
	    //     this.tableFiltersData = this.tableFiltersData.map( (item, i) => {
		// 		if ( index != i ) item.open = false
		// 		return item
		// 	})
		// }
	},
	props: {
		tableFilters: Array,
		feTheme: Object,
		dtPost: Object,
		side: Boolean,
		softFilterArgument: Object
	},

	mounted() {
		const softFilterArgument = this.softFilterArgument
		this.tableFiltersData = this.tableFilters.map( item => {
			item.open = false
			item.active = false
			if ( softFilterArgument ) {
				for ( let k in softFilterArgument ) {
					if ( k == item.column_name ) {
						item.active = true
						// item.options = item.options.map( el => {
							// if ( el.term = softFilterArgument[k] ) {
									
					}		
				}
			}
			
			return item
		})

		// window.addEventListener('click', (e) => {
	    //     if ( document.getElementById('dropdown-filters') && document.getElementById('dropdown-filters').contains(e.target) ) {
	    //         // showDropdown.value = !showDropdown.value

	    //     }
	    //     else {
	    //         this.tableFiltersData = this.tableFiltersData.map( (item, index) => {
		// 			item.open = false
		// 			return item
		// 		})
	    //     }
	    // } )
	}
}
</script>